module.exports = __webpack_public_path__ + "img/erica.b4350465.png";